import graphqlClient from "../../../apollo";

class DashboardProvider {

    getVentasPorMarca() {
        return graphqlClient.query({
            query: require('./gql/getVentasPorMarca.graphql'),
            fetchPolicy: "network-only"
        })
    }

    getVentasPorModelo() {
        return graphqlClient.query({
            query: require('./gql/getVentasPorModelo.graphql'),
            fetchPolicy: "network-only"
        })
    }

    getVentasPorDia() {
        return graphqlClient.query({
            query: require('./gql/getVentasPorDia.graphql'),
            fetchPolicy: "network-only"
        })
    }

    getChartDataVentasPorMarca(filters) {
        return graphqlClient.query({
            query: require('./gql/chartDataVentasPorMarca.graphql'),
            variables: {
                filters
            },
            fetchPolicy: "network-only"
        })
    }

    getChartDataVentasPorModelo(filters) {
        return graphqlClient.query({
            query: require('./gql/chartDataVentasPorModelo.graphql'),
            variables: {
                filters
            },
            fetchPolicy: "network-only"
        })
    }

    getChartDataVentasPorDia(filters) {
        return graphqlClient.query({
            query: require('./gql/chartDataVentasPorDia.graphql'),
            variables: {
                filters
            },
            fetchPolicy: "network-only"
        })
    }

    getChartDataVentasPorMedioDePago(filters) {
        return graphqlClient.query({
            query: require('./gql/chartDataVentasPorMedioDePago.graphql'),
            variables: {
                filters
            },
            fetchPolicy: "network-only"
        })
    }

    getChartDataVentasPorTamanio(filters) {
        return graphqlClient.query({
            query: require('./gql/chartDataVentasPorTamanio.graphql'),
            variables: {
                filters
            },
            fetchPolicy: "network-only"
        })
    }

    getChartDataProductosMasVendidos(filters) {
        return graphqlClient.query({
            query: require('./gql/chartDataProductosMasVendidos.graphql'),
            variables: {
                filters
            },
            fetchPolicy: "network-only"
        })
    }

    getChartDataIngresosVsDescuentos(filters) {
        return graphqlClient.query({
            query: require('./gql/chartDataIngresosVsDescuentos.graphql'),
            variables: {
                filters
            },
            fetchPolicy: "network-only"
        })
    }

    getChartDataVentasPorMes(filters) {
        return graphqlClient.query({
            query: require('./gql/chartDataVentasPorMes.graphql'),
            variables: {
                filters
            },
            fetchPolicy: "network-only"
        })
    }

    getTicketPromedio(filters) {
        return graphqlClient.query({
            query: require('./gql/ticketPromedio.graphql'),
            variables: {
                filters
            },
            fetchPolicy: "network-only"
        })
    }

    generateExcel(filters) {
        return graphqlClient.query({
            query: require('./gql/generateExcel.graphql'),
            variables: {
                filters
            },
            fetchPolicy: "network-only"
        })
    }

    getChartDataDevolucionesPorDia(filters) {
        return graphqlClient.query({
            query: require('./gql/chartDataDevolucionesPorDia.graphql'),
            variables: { filters },
            fetchPolicy: "network-only"
        })
    }

    getChartDataOrdenesVentaPorDia(filters) {
        return graphqlClient.query({
            query: require('./gql/chartDataOrdenesVentaPorDia.graphql'),
            variables: { filters },
            fetchPolicy: "network-only"
        })
    }

    getChartDataOrdenesCompraPorDia(filters) {
        return graphqlClient.query({
            query: require('./gql/chartDataOrdenesCompraPorDia.graphql'),
            variables: { filters },
            fetchPolicy: "network-only"
        })
    }

    getChartDataFlujoCajaPorDia(filters) {
        return graphqlClient.query({
            query: require('./gql/chartDataFlujoCajaPorDia.graphql'),
            variables: { filters },
            fetchPolicy: "network-only"
        })
    }

}

export default new DashboardProvider()


